import api from './api';

export interface TikTokStatus {
  configured: boolean;
  authorized: boolean;
  account: string;
  tokenExpired: boolean;
  expiresAt?: number;
  grantedScopes: string[];
  canUploadToInbox: boolean;
  reauthorizationRequired: boolean;
}

export interface TikTokUser {
  open_id: string;
  union_id: string;
  display_name: string;
  avatar_url: string;
  bio_description: string;
  profile_deep_link: string;
  is_verified: boolean;
}

export interface UploadInitResponse {
  success: boolean;
  publishId: string;
  uploadUrl: string;
}

export interface PublishStatusResponse {
  publishId: string;
  status: 'PUBLISHING' | 'PUBLISHED' | 'FAILED' | 'PROCESSING';
  videoId?: string;
  error?: string;
}

export interface TikTokCreatorInfo {
  creator_avatar_url: string;
  creator_username: string;
  creator_nickname: string;
  privacy_level_options: Array<'PUBLIC_TO_EVERYONE' | 'MUTUAL_FOLLOW_FRIENDS' | 'SELF_ONLY'>;
  comment_disabled: boolean;
  duet_disabled: boolean;
  stitch_disabled: boolean;
  max_video_post_duration_sec: number;
}

export interface TikTokAccount {
  id: string;
  expiresAt: number;
}

export const tiktokApi = {
  // OAuth endpoints
  getAuthUrl: (account: string = 'default') => api.get(`/tiktok/auth-url?account=${encodeURIComponent(account)}`),

  getAccounts: () => api.get('/tiktok/accounts'),
  
  handleCallback: (code: string, state: string, account: string = 'default') =>
    api.post('/tiktok/oauth/callback', { code, state, account }),
  
  refreshToken: (account: string = 'default') =>
    api.post('/tiktok/refresh', { account }),
  
  // User endpoints
  getUser: (account: string = 'default') =>
    api.get(`/tiktok/user?account=${account}`),

  getCreatorInfo: (account: string = 'default') =>
    api.get(`/tiktok/creator-info?account=${account}`),
  
  getStatus: (account: string = 'default') =>
    api.get(`/tiktok/status?account=${account}`),
  
  // Video upload endpoints
  initVideoUpload: (videoUrl: string, account?: string) =>
    api.post('/tiktok/video/upload-init', {
      videoUrl,
      account: account || 'default',
    }),
  
  getPublishStatus: (publishId: string, account: string = 'default') =>
    api.get(`/tiktok/video/publish-status/${publishId}?account=${account}`),
  
  // Token management
  revoke: (account: string = 'default') =>
    api.post('/tiktok/revoke', { account }),
};
